import Controller from '@ember/controller';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { CapitalDepositInProgress } from 'register-partners-js/react/components/resume/capital-deposit-in-progress';

export default class AlreadyCreatedController extends Controller {
  mainLayout = MainLayout;
  capitalDepositInProgress = CapitalDepositInProgress;
}
